export default () => ({

    savable: {
        ['x-on:keydown.meta.s.window.prevent']() {
            return this.$el.submit();
        },
    },
})
